import { parse, theme } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const container = parse({
  position: "fixed",
  height: "screen",
  width: "screen",
  bg: "black"
}, "cj6n6au");
export const nav = parse({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "auto"
}, "n1rx69o4");
export const navLink = parse({
  fontFamily: "artegra",
  fontWeight: "medium",
  position: "relative",
  mb: "32"
}, "n16fv7wu");

require("./MobileNav.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MobileNav.styles.ts");